<template>
  <div class="list-search">
    <form>
      <div class="row row-clear-sm-6-md-4">
        <div class="col-sm-6 col-md-4">
          <div class="form-group">
            <label class="sr-only">Location</label>
            <selectize
              ref="locations"
              class="selectize selectize-multiple"
              multiple
              name="location"
              v-model="stateLocations"
              placeholder="Location"
              :options="locationOptions"/>
          </div>
        </div>
        <div class="col-sm-6 col-md-4">
          <div class="form-group">
            <label class="sr-only">Opportunity Type</label>
            <selectize
              ref="opportunity"
              class="selectize selectize-multiple"
              multiple
              name="opportunity"
              v-model="stateOpportunities"
              placeholder="Opportunity Type"
              :options="opportunityOptions"/>
          </div>
        </div>
        <div class="col-sm-6 col-md-4">
          <div class="form-group">
            <label class="sr-only">Date Due</label>
            <div class="input-group">
              <flatpickr
                v-model="dueDate"
                :config="flatPickerDateConfig"
                placeholder="Due Date"
                class="form-control"
                name="date_range"/>

              <span class="input-group-addon" data-toggle>
                <i class="fa fa-calendar"></i>
              </span>

              <span class="input-group-addon" data-clear>
                <i class="fa fa-times"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4">
          <div class="form-group">
            <label class="sr-only">Amount</label>
            <div class="row">
              <div class="col-xs-6">
                <input name="status_low" v-model="stateAmountLow" type="text" class="form-control" placeholder="Amount Low" />
              </div>
              <div class="col-xs-6">
                <input name="status_hight" v-model="stateAmountHigh" type="text" class="form-control" placeholder="Amount High" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4">
          <div class="form-group">
            <label class="sr-only">Status</label>
            <selectize
              ref="status"
              class="selectize selectize-multiple"
              multiple
              name="status"
              v-model="stateStatus"
              key-context="locations"
              :preLoad="true"
              placeholder="Payment Status"
              :options="statusOptions"/>
          </div>
        </div>
        <div class="col-sm-6 col-md-4" v-if="$userIsGlobalAdmin && regionOptions.length > 1">
          <div class="form-group">
            <label class="sr-only">Region</label>
            <selectize
              ref="regions"
              class="selectize selectize-multiple"
              multiple
              name="region"
              v-model="stateRegions"
              placeholder="Region"
              :options="regionOptions"/>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 pull-right" style="padding-bottom: 8px;">
          <slot name="button"/>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { stateMapper } from 'mixins/payments/filters'
import { mapActions, mapState } from 'vuex'
import { map } from 'lodash'
import Selectize from '../ext/codium/CodiumSelectize'
import Flatpickr from 'vue-flatpickr-component'

export default {
  mixins: [stateMapper],

  components: {
    Selectize,
    Flatpickr
  },

  props: {
    applyFilters: {
      required: false,
      type: Function
    }
  },

  data () {
    return {
      opportunityOptions: [],
      locationOptions: [],
      regionOptions: [],
      statusOptions: [
        { id: 'unpaid', text: 'Unpaid' },
        { id: 'sent', text: 'Sent' },
        { id: 'paid', text: 'Paid' },
        { id: 'overdue', text: 'Overdue' }
      ],
      flatPickerDateConfig: {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        wrap: true,
        mode: 'range'
      }
    }
  },

  computed: {
    ...mapState('payment', ['filters']),

    dueDate: {
      get () {
        if (this.stateDateLow === null || this.stateDateHigh === null) {
          return null
        }

        return [this.stateDateLow, this.stateDateHigh]
      },

      set (value) {
        if (value === null || value === undefined) {
          this.stateDateLow = null
          this.stateDateHigh = null
        } else {
          [this.stateDateLow, this.stateDateHigh] = value.split(' to ')
        }
      }
    }
  },

  created () {
    this.getOpportunities()
      .then((response) => {
        this.opportunityOptions = map(response.data, opportunity => ({ id: opportunity.id, text: opportunity.name }))
      })

    this.getLocations()
      .then((response) => {
        this.locationOptions = map(response.data, location => ({ id: location.shortname, text: location.shortname }))
      })

    if (this.$userIsGlobalAdmin && !this.$vlastMode) {
      this.getRegions()
        .then((response) => {
          this.regionOptions = map(response.data, region => ({id: region.id, text: region.name}))
          this.stateRegions = [this.$user.region_id]
          if (this.applyFilters) {
            this.applyFilters()
          }
        })
    }
  },

  methods: {
    ...mapActions('region', ['getRegions']),
    ...mapActions('payment', ['getPayments']),
    ...mapActions('location', ['getLocations']),
    ...mapActions('opportunity', ['getOpportunities'])
  }
}
</script>
